export default {
  noDataAvailable: 'No data available',
  dismiss: 'Dismiss',
  timePicker: {
    hour: 'Hour',
    minute: 'Minute',
    cancel: 'Cancel',
    apply: 'Apply',
    clear: 'Clear',
    oClock: '',
  },
}
